module.exports = __webpack_public_path__ + "static/media/IMG_20200717_214513_784.3ce6fa35.jpg";